(ns iris.logs.views.header
  (:require
   [re-frame.core :as re-frame]
   [iris.logs.views.post :refer [screening-badge]]
   [iris.posts.common :refer [agor-edit-url]]
   [iris.posts.subs :as posts-subs]))

(defn header-btns [header]
  (let [ruid     (str "/" header)
        ruid-enc (js/encodeURIComponent ruid)
        ss       @(re-frame/subscribe [::posts-subs/screning-status ruid])
        hdr      @(re-frame/subscribe [::posts-subs/header])]
    [:div
     (when (and (:genus hdr) (:ws hdr) (:title hdr))
       [:a {:href   (agor-edit-url ruid (:genus hdr) (:ws hdr) (:title hdr))
            :target "_blank"
            :class  "btn btn-primary"}
        [:i {:class "glyphicon glyphicon-edit"}]
        " Edit"])
     " "
     [:a {:href  (str "/posts?board=" ruid-enc) :class "btn btn-primary"}
      [:i {:class "glyphicon glyphicon-list"}]
      " All posts"]
     " "
     [screening-badge ss ruid]]))